import { useEffect, useState } from "react";
import { Alert, Breadcrumb, Button, Spinner, Table } from "react-bootstrap";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { Link } from "react-router-dom";
import userServices from "../../../redux/services/userServices";
import Swal from "sweetalert2";

const StoneDust = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    async function fetchCompanies() {
      setLoading(true);
      setError(null);
      let response = await userServices.view();
      setLoading(false);
      if (response.status) {
        setCompanies(response?.data);
      } else {
        if (response?.data?.data?.message)
          setError(response?.data?.data?.message);
        else if (response?.error?.message) setError(response?.error?.message);
      }
    }
    fetchCompanies();
  }, [refresh]);

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let response = await userServices.destory(id);

        if (response.status) {
          setRefresh((r) => parseInt(r) + 1);
        }
      }
    });
  };

  return (
    <div>
      <h1>Stone Dust</h1>
      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/admin" }}>
          Dashboard
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Stone Dust</Breadcrumb.Item>
      </Breadcrumb>
      <div className="bg-white shadow-sm p-3 rounded">
        <h4 className="text-primary pb-2 border-bottom mb-3">View Companies</h4>

        {error ? <Alert variant="danger">{error}</Alert> : null}

        {!loading ? (
          <div>
            {companies.length ? (
              <Table bordered>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>StoneDustname</th>
                    <th>Role</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {companies.map((row, index) => (
                    <tr key={index}>
                      <td>{index + 1}.</td>
                      <td>{row.name}</td>
                      <td>{row.login}</td>
                      <td>{row?.role?.name}</td>
                      <td>
                        <Link
                          to={`/admin/user/edit/${row.id}`}
                          className="btn btn-link text-primary"
                        >
                          <MdModeEdit />
                        </Link>
                        <Button
                          variant="link"
                          className="text-danger"
                          onClick={() => handleDelete(row.id)}
                        >
                          <MdDelete />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <div>No record(s) found.</div>
            )}
          </div>
        ) : (
          <div className="text-center">
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        )}
      </div>
    </div>
  );
};

export default StoneDust;
